var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statement-react"},[_c('add-button',{on:{"toggleOn":function($event){_vm.addConvoStatement()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }